import { getCookieVal } from "@/tool/index";
import store from "@/store";

// 模块级单例状态
let wsInstance = null;
let reconnectTimer = null;
let heartbeatTimer = null;
let forcedClose = false;
let reconnectAttempt = 0;
const RECONNECT_BASE_MS = 1000;
const RECONNECT_MAX_MS = 30000;

const getSocket = () => {
  if (!wsInstance || wsInstance.readyState === WebSocket.CLOSED) {
    const token = getCookieVal("iyuanwu_token");
    if (!token) return null;
    forcedClose = false;
    wsInstance = new WebSocket(process.env.VUE_APP_WEBSOCKET);

    wsInstance.onopen = () => {
      reconnectAttempt = 0;
      wsInstance.send(JSON.stringify({ token, op: 2 }));
      startHeartbeat();
    };

    wsInstance.onerror = (e) => {
      console.log("数据传输发生错误", e);
    };

    wsInstance.onmessage = (e) => {
      store.dispatch("updateTaskDetail", JSON.parse(e.data));
    };

    wsInstance.onclose = () => {
      stopHeartbeat();
      if (!forcedClose) {
        reconnect();
      }
    };
  }
  return wsInstance;
};

const startHeartbeat = () => {
  stopHeartbeat();
  heartbeatTimer = setInterval(() => {
    if (wsInstance && wsInstance.readyState === WebSocket.OPEN) {
      wsInstance.send(JSON.stringify({ op: 14 }));
    }
  }, 60000);
};

const reconnect = () => {
  if (reconnectTimer) return;
  reconnectAttempt++;
  // 阶梯式延时：1s → 2s → 4s → 8s → 16s → 30s（封顶）
  const delay = Math.min(
    RECONNECT_BASE_MS * 2 ** (reconnectAttempt - 1),
    RECONNECT_MAX_MS
  );
  reconnectTimer = setTimeout(() => {
    reconnectTimer = null;
    getSocket();
  }, delay);
};

const stopHeartbeat = () => {
  if (heartbeatTimer) {
    clearInterval(heartbeatTimer);
    heartbeatTimer = null;
  }
};

/** 判断 WebSocket 是否处于连接状态 */
const isConnected = () => {
  return wsInstance && wsInstance.readyState === WebSocket.OPEN;
};

/** 断开后立即重连 */
const forceReconnect = () => {
  if (wsInstance) {
    forcedClose = true;
    wsInstance.close();
  }
  wsInstance = null;
  reconnectAttempt = 0;
  if (reconnectTimer) {
    clearTimeout(reconnectTimer);
    reconnectTimer = null;
  }
  return getSocket();
};

export {
  getSocket,
  startHeartbeat,
  reconnect,
  stopHeartbeat,
  isConnected,
  forceReconnect,
};
